var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-dialog",
        {
          attrs: { "full-width": !_vm.isMobile, "max-width": "500" },
          model: {
            value: _vm.showCopyLoadHelpDialog,
            callback: function($$v) {
              _vm.showCopyLoadHelpDialog = $$v
            },
            expression: "showCopyLoadHelpDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-toolbar",
                { attrs: { card: "" } },
                [
                  _c("v-toolbar-title", { attrs: { flat: "" } }, [
                    _vm._v("Repeat a Customer Load")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n      Frequently, you find that you run the same load for a customer: same customer, same pickup\n      location, same delivery location, same load instructions and driver directions.  Repeating\n      a load makes putting the next load in your planner simple.\n      "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n      Repeating a load does not change or affect the load currently in your planner.  It creates\n      a brand new load in your planner.\n      "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("v-icon", { attrs: { color: "accent" } }, [_vm._v("redo")]),
              _vm._v(" "),
              _c("strong", [_vm._v("Create this load again.")]),
              _vm._v(
                " By creating the load this way, you provide when the\n      load is scheduled to be picked up next. Additionally, it will be in your repeat load list\n      so it will be easy to plan this load quickly and easily.\n\n      "
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: { click: _vm.closeCopyLoadHelpDialog }
                    },
                    [_vm._v("\n          Got It\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.transaction
        ? _c("v-repeat-load-group-dialog", {
            attrs: {
              loadGroupId: _vm.planningLoad.humanId,
              sponsor: _vm.listingSponsorName,
              origin: _vm._f("originName")(_vm.planningLoad.loadGroup.details),
              destination: _vm._f("destinationName")(
                _vm.planningLoad.loadGroup.details
              ),
              count: _vm.planningLoad.loadGroup.loadCount,
              isMobile: _vm.isMobile,
              loading: _vm.loadingBtn,
              company: _vm.company,
              "load-group": _vm.planningLoad.loadGroup
            },
            on: {
              cancel: _vm.closeCopyLoadDialog,
              newLoad: _vm.closeCopyLoadDialog
            },
            model: {
              value: _vm.showCopyLoadDialog,
              callback: function($$v) {
                _vm.showCopyLoadDialog = $$v
              },
              expression: "showCopyLoadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        extended: _vm.isMobile,
                        dense: !_vm.isMobile,
                        flat: ""
                      }
                    },
                    [
                      _vm.verifiedCustomer
                        ? _c("v-icon", { attrs: { color: "green" } }, [
                            _vm._v("\n            verified_user\n          ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-title",
                        { attrs: { color: "primary" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.listingSponsorName) +
                              "\n            "
                          ),
                          _vm.loadGroupNickname(_vm.planningLoad)
                            ? [
                                _vm._v(
                                  "\n               (" +
                                    _vm._s(
                                      _vm.loadGroupNickname(_vm.planningLoad)
                                    ) +
                                    ")\n            "
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: _vm.isMobile ? "extension" : "default" },
                        [
                          _vm._t("toolbarItems", function() {
                            return [
                              _vm._v(
                                "\n              edit toolbar items\n            "
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      !_vm.disableCustomerEdition &&
                      _vm.editForm &&
                      !_vm.repeating
                        ? _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "accent",
                                        "text-color": "white",
                                        small: ""
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("business")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                { staticClass: "pl-2" },
                                [
                                  _c(
                                    "v-combobox",
                                    {
                                      staticClass: "mr-3",
                                      attrs: {
                                        disabled: _vm.disableCustomerEdition,
                                        loading:
                                          _vm.loadingCompanies &&
                                          !!_vm.search &&
                                          !_vm.disableCustomerEdition,
                                        items:
                                          _vm.search && _vm.search.length > 3
                                            ? _vm.allCompanies
                                            : [],
                                        "search-input": _vm.search,
                                        "hide-no-data": !(
                                          _vm.search && _vm.search.length > 3
                                        ),
                                        "item-text": "searchName",
                                        "return-object": "",
                                        "hide-details": "",
                                        label: "Customer company"
                                      },
                                      on: {
                                        "update:searchInput": function($event) {
                                          _vm.search = $event
                                        },
                                        "update:search-input": function(
                                          $event
                                        ) {
                                          _vm.search = $event
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "item",
                                            fn: function(data) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color: _vm._.get(
                                                        data,
                                                        "item.accountStatus.verified",
                                                        null
                                                      )
                                                        ? "green"
                                                        : "transparent"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    verified_user\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "ml-1" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.searchName
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1309998520
                                      ),
                                      model: {
                                        value: _vm.customerCompany,
                                        callback: function($$v) {
                                          _vm.customerCompany = $$v
                                        },
                                        expression: "customerCompany"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "template",
                                        { slot: "no-data" },
                                        [
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      '\n                        No results matching "'
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(_vm._s(_vm.search))
                                                    ]),
                                                    _vm._v(
                                                      '".\n                        Press '
                                                    ),
                                                    _c("kbd", [_vm._v("tab")]),
                                                    _vm._v(
                                                      " to use this customer's name\n                      "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editForm
                        ? _c(
                            "v-list-tile",
                            {
                              class: { "amount-edition-tile": _vm.editForm },
                              attrs: { avatar: "" }
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "accent",
                                        "text-color": "white",
                                        small: ""
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("money")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                { staticClass: "pl-2" },
                                [
                                  _c("v-float-field", {
                                    staticClass: "mt-0",
                                    attrs: {
                                      label: "Billable Amount ($)",
                                      messages: _vm.loadedDistanceMessage
                                    },
                                    model: {
                                      value: _vm.updatedBillableAmount,
                                      callback: function($$v) {
                                        _vm.updatedBillableAmount = $$v
                                      },
                                      expression: "updatedBillableAmount"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dispatched &&
                      !_vm.loadGroupOwnerIsSponsor(_vm.planningLoad)
                        ? [
                            _c("v-subheader", [_vm._v("Dispatch Details")]),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              [
                                _c(
                                  "v-list-tile-action",
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        attrs: { color: "primary", small: "" }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "white" } },
                                          [_vm._v("share")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.loadGroupOwnerName(
                                            _vm.planningLoad
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-sub-title",
                                      { staticClass: "font-italic" },
                                      [
                                        _vm._v(
                                          "\n                  Dispatched by " +
                                            _vm._s(
                                              _vm.planningLoad
                                                .createdByDisplayName
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.repeating || _vm.planningLoad.nickname
                        ? _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        "text-color": "white",
                                        small: "",
                                        color: "accent"
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("vpn_key")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                { staticClass: "pl-2" },
                                [
                                  _vm.planningLoad.nickname
                                    ? _c("v-list-tile-title", [
                                        _vm._v(
                                          _vm._s(_vm.planningLoad.nickname)
                                        )
                                      ])
                                    : _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "give this repeat load a nickname"
                                        )
                                      ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "green",
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                $" +
                                      _vm._s(_vm.loadedDistanceRate) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Load Pays $" +
                                    _vm._s(
                                      _vm.updatedBillableAmount ||
                                        _vm.loadAmount ||
                                        0
                                    ) +
                                    " each\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _vm._v(
                                  "\n                $" +
                                    _vm._s(_vm.loadedDistanceRate) +
                                    "/" +
                                    _vm._s(_vm.siteDistanceMeasureUnitLabel) +
                                    "\n              "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.transaction
                        ? _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "accent",
                                        "text-color": "white",
                                        small: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.displayLoadCount) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _vm.editForm
                                    ? _c(
                                        "span",
                                        { staticClass: "mr-2 pl-2 pr-2" },
                                        [
                                          _c(
                                            "v-truck-counter-field",
                                            {
                                              attrs: {
                                                min: _vm.planningLoadGroupActiveBookedTruckCount(
                                                  _vm.planningLoad
                                                )
                                              },
                                              model: {
                                                value:
                                                  _vm.updatedLoadTruckCount,
                                                callback: function($$v) {
                                                  _vm.updatedLoadTruckCount = $$v
                                                },
                                                expression:
                                                  "updatedLoadTruckCount"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: { slot: "increment" },
                                                  slot: "increment"
                                                },
                                                [_vm._v("add")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: { slot: "decrement" },
                                                  slot: "decrement"
                                                },
                                                [_vm._v("remove")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-list-tile-title",
                                        { staticClass: "pl-2" },
                                        [
                                          _vm.planningLoad.loadGroup
                                            .loadCount === 1
                                            ? _c("span", [
                                                _vm._v("load needs a truck")
                                              ])
                                            : _vm.dispatched
                                            ? _c("span", [
                                                _vm.displayLoadCount === 1
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "load needs a truck"
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        "loads need a truck"
                                                      )
                                                    ])
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "\n                  of "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.planningLoad.loadGroup
                                                        .loadCount
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  " loads need a truck\n                "
                                                )
                                              ])
                                        ]
                                      )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-subheader", [_vm._v("Load Details")]),
                      _vm._v(" "),
                      !_vm.repeating
                        ? _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        "text-color": "white",
                                        small: "",
                                        color: "accent"
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("event")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                { staticClass: "pl-2" },
                                [
                                  _vm.editForm
                                    ? [
                                        _c("date-picker", {
                                          attrs: {
                                            "input-id":
                                              "pickupTimePickerPreview",
                                            placeholder: "Pickup Date",
                                            type: "datetime",
                                            format:
                                              "cccc, LLLL dd yyyy hh:mm a",
                                            "input-class": "picker",
                                            phrases: {
                                              ok: "Continue",
                                              cancel: "Cancel"
                                            },
                                            "hour-step": 1,
                                            "minute-step": 60,
                                            "week-start": 7,
                                            "use12-hour": "",
                                            auto: ""
                                          },
                                          model: {
                                            value: _vm.updatedPickupTime,
                                            callback: function($$v) {
                                              _vm.updatedPickupTime = $$v
                                            },
                                            expression: "updatedPickupTime"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            "\n                  Booked aren't modified when date changes.\n                "
                                          )
                                        ])
                                      ]
                                    : [
                                        _c(
                                          "span",
                                          { on: { click: _vm.enterEditMode } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm._f("formatDate")(
                                                    _vm.planningLoad.loadGroup
                                                      .scheduledPickupTime
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "accent",
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("arrow_upward")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.disableAddressView
                            ? _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("originRegion")(
                                            _vm.planningLoad.loadGroup.details
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _c(
                                "v-list-tile-content",
                                { staticClass: "pl-2" },
                                [
                                  _vm.editForm && !_vm.repeating
                                    ? _c("AddressSearch", {
                                        attrs: {
                                          label: "From (Origin Address)"
                                        },
                                        model: {
                                          value: _vm.updatedOriginLocation,
                                          callback: function($$v) {
                                            _vm.updatedOriginLocation = $$v
                                          },
                                          expression: "updatedOriginLocation"
                                        }
                                      })
                                    : [
                                        _c(
                                          "v-list-tile-title",
                                          { on: { click: _vm.enterEditMode } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("originName")(
                                                  _vm.planningLoad.loadGroup
                                                    .details
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("originAddress")(
                                                _vm.planningLoad.loadGroup
                                                  .details
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "accent",
                                    small: "",
                                    "text-color": "white"
                                  }
                                },
                                [_c("v-icon", [_vm._v("play_for_work")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.disableAddressView
                            ? _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("destinationRegion")(
                                            _vm.planningLoad.loadGroup.details
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _c(
                                "v-list-tile-content",
                                { staticClass: "pl-2" },
                                [
                                  _vm.editForm && !_vm.repeating
                                    ? _c("AddressSearch", {
                                        attrs: {
                                          label: "To (Destination Address)"
                                        },
                                        model: {
                                          value: _vm.updatedDestinationLocation,
                                          callback: function($$v) {
                                            _vm.updatedDestinationLocation = $$v
                                          },
                                          expression:
                                            "updatedDestinationLocation"
                                        }
                                      })
                                    : [
                                        _c(
                                          "v-list-tile-title",
                                          { on: { click: _vm.enterEditMode } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("destinationName")(
                                                  _vm.planningLoad.loadGroup
                                                    .details
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("destinationAddress")(
                                                _vm.planningLoad.loadGroup
                                                  .details
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                ],
                                2
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v("Requirements and Instructions")
                      ]),
                      _vm._v(" "),
                      _vm.requireWashout
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "icon-base",
                                    {
                                      attrs: {
                                        width: "35",
                                        height: "35",
                                        "icon-color": "#352208",
                                        "icon-name": "hose"
                                      }
                                    },
                                    [_c("icon-hose")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Washout Before Loading")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.requireWoodChips
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "icon-base",
                                    {
                                      attrs: {
                                        width: "35",
                                        height: "35",
                                        "icon-color": "#352208",
                                        viewBox: "0 0 5 5",
                                        "icon-name": "wood"
                                      }
                                    },
                                    [_c("icon-wood")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Provide Fresh Wood Chips")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.requireWeatherboards
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "icon-base",
                                    {
                                      attrs: {
                                        width: "35",
                                        height: "35",
                                        "icon-name": "cold",
                                        "icon-color": "#352208"
                                      }
                                    },
                                    [_c("icon-cold")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Must Use Weatherboards")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editForm
                        ? _c(
                            "v-container",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "", lg6: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          rows: 2,
                                          label: "Dispatcher instructions"
                                        },
                                        model: {
                                          value:
                                            _vm.updatedDispatchInstructions,
                                          callback: function($$v) {
                                            _vm.updatedDispatchInstructions = $$v
                                          },
                                          expression:
                                            "updatedDispatchInstructions"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.dispatchInstructions
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _c("b", [
                                      _vm._v("Dispatcher instructions: ")
                                    ]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.dispatchInstructions) +
                                        "\n              "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _c("em", [
                                      _vm._v(
                                        "Dispatcher instructions not provided"
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _vm.editForm
                        ? _c(
                            "v-container",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "", lg6: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          rows: 2,
                                          label: "Driver instructions"
                                        },
                                        model: {
                                          value: _vm.updatedDriverInstructions,
                                          callback: function($$v) {
                                            _vm.updatedDriverInstructions = $$v
                                          },
                                          expression:
                                            "updatedDriverInstructions"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.driverInstructions
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _c("b", [_vm._v("Driver instructions: ")]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.driverInstructions) +
                                        "\n              "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _c("em", [
                                      _vm._v("Driver instructions not provided")
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                      _vm._v(" "),
                      !_vm.requireWashout &&
                      !_vm.requireWoodChips &&
                      !_vm.requireWeatherboards
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _c("em", [
                                      _vm._v("No provided hauling conditions")
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29fc8604", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29fc8604","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoWidgets/EditLoadDetails.vue
// module id = null
// module chunks = 